var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "VModal",
        {
          attrs: { title: "เพิ่มลูกค้า" },
          model: {
            value: _vm.visibleCreateForm,
            callback: function($$v) {
              _vm.visibleCreateForm = $$v
            },
            expression: "visibleCreateForm"
          }
        },
        [
          _c("StadiumBoostInsertCustomerForm", {
            attrs: { "boost-id": _vm.id },
            on: { success: _vm.closeCreateForm }
          })
        ],
        1
      ),
      _c(
        "VModal",
        {
          attrs: { title: "แก้ไขข้อมูลลูกค้า" },
          model: {
            value: _vm.visibleUpdateForm,
            callback: function($$v) {
              _vm.visibleUpdateForm = $$v
            },
            expression: "visibleUpdateForm"
          }
        },
        [
          _c("StadiumBoostUpdateCustomerForm", {
            attrs: { "boost-id": _vm.id, "customer-id": _vm.selectedEntityId },
            on: { success: _vm.closeUpdateForm }
          })
        ],
        1
      ),
      _c("h3", [_vm._v("ลูกค้าจากนอกระบบ")]),
      _c(
        "a-button",
        {
          staticClass: "product-local-customers__action-button",
          attrs: { type: "primary" },
          on: { click: _vm.onClickCreate }
        },
        [_vm._v("\n        เพิ่มลูกค้า\n    ")]
      ),
      _c("VTable", {
        attrs: {
          "data-source": _vm.dataSource,
          "flexible-width": "240px",
          columns: _vm.columns,
          loading: _vm.loading,
          "custom-row": _vm.createClickToEditRow
        },
        scopedSlots: _vm._u([
          {
            key: "memberType",
            fn: function(ref) {
              var text = ref.text
              var record = ref.record
              return [
                _c("Member", {
                  attrs: {
                    "product-id": _vm.id,
                    "tx-item": record,
                    model: text
                  }
                })
              ]
            }
          },
          {
            key: "isPaid",
            fn: function(ref) {
              var record = ref.record
              return [
                _c("a-checkbox", {
                  attrs: { checked: record.isPaid },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    },
                    change: function(e) {
                      return _vm.onIsPaidChange(e, record)
                    }
                  }
                })
              ]
            }
          },
          {
            key: "numberOfPeople",
            fn: function(ref) {
              var text = ref.text
              return [
                _vm._v("\n            " + _vm._s(text) + " "),
                _c("a-icon", { attrs: { type: "team" } })
              ]
            }
          },
          {
            key: "operation",
            fn: function(ref) {
              var record = ref.record
              return [
                _vm.dataSource.length
                  ? _c(
                      "a-popconfirm",
                      {
                        attrs: { title: "ยืนยันการลบ?" },
                        on: {
                          confirm: function() {
                            return _vm.onDelete(record.id)
                          }
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          },
                          [_vm._v("ลบ")]
                        )
                      ]
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }